import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.notifications');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-notifications',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.notifications/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageNotificationsComponent implements OnInit {
    public notifications: any[] = [];
    public total: number = 0;
    public unread: number = 0;
    public page: number = 1;
    public dump: number = 20;
    public filter: string = '';
    public loading: boolean = true;
    public tab: string = 'all';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        let params: any = { page: this.page, dump: this.dump };
        if (this.tab === 'unread') params.is_read = 'false';
        if (this.tab === 'read') params.is_read = 'true';

        const res = await wiz.call("list", params);
        if (res.code === 200) {
            this.notifications = res.data.rows || [];
            this.total = res.data.total || 0;
            this.unread = res.data.unread || 0;
        }

        this.loading = false;
        await this.service.render();
    }

    public async setTab(tab: string) {
        this.tab = tab;
        this.page = 1;
        await this.load();
    }

    public async onPage(p: number) {
        this.page = p;
        await this.load();
    }

    public async markRead(noti: any) {
        if (noti.is_read) return;
        await wiz.call("markRead", { id: noti.id });
        noti.is_read = true;
        this.unread = Math.max(0, this.unread - 1);
        if (noti.link) {
            this.service.href(noti.link);
        }
        await this.service.render();
    }

    public async markAllRead() {
        await wiz.call("markAllRead");
        this.notifications.forEach((n: any) => n.is_read = true);
        this.unread = 0;
        await this.service.render();
    }

    public async deleteNoti(noti: any) {
        await wiz.call("deleteNoti", { id: noti.id });
        await this.load();
    }

    public async deleteAll() {
        const res = await this.service.alert.show({ title: '알림 전체 삭제', message: '모든 알림을 삭제하시겠습니까?', action: '삭제', actionBtn: 'btn-red' });
        if (!res) return;
        await wiz.call("deleteAll");
        await this.load();
    }

    public categoryColor(cat: string): string {
        const map: any = { system: 'bg-blue-100 text-blue-700', board: 'bg-green-100 text-green-700', member: 'bg-purple-100 text-purple-700', storage: 'bg-amber-100 text-amber-700' };
        return map[cat] || 'bg-gray-100 text-gray-600';
    }

    public categoryIcon(cat: string): string {
        const map: any = { system: '⚙️', board: '📋', member: '👤', storage: '📁' };
        return map[cat] || '🔔';
    }

    public timeAgo(dateStr: string): string {
        if (!dateStr) return '';
        const now = new Date();
        const date = new Date(dateStr);
        const diff = Math.floor((now.getTime() - date.getTime()) / 1000);
        if (diff < 60) return '방금 전';
        if (diff < 3600) return Math.floor(diff / 60) + '분 전';
        if (diff < 86400) return Math.floor(diff / 3600) + '시간 전';
        if (diff < 604800) return Math.floor(diff / 86400) + '일 전';
        return dateStr.substring(0, 10);
    }

    get totalPages(): number {
        return Math.ceil(this.total / this.dump);
    }

    get pageRange(): number[] {
        const pages: number[] = [];
        const start = Math.max(1, this.page - 2);
        const end = Math.min(this.totalPages, this.page + 2);
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    }
}

export default PageNotificationsComponent;